















































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { Action, Mutation } from 'vuex-class'
import { mapMutations, mapActions, mapState } from 'vuex'
import Account from '@/components/gambling/AccountComponents/Account.vue'
import SelectLayout from '@/components/gambling/SelectLayout.vue'
import AccountBalance from '@/components/gambling/AccountBalance.vue'
import { openAccount } from '@/utils/gamblingHelpers'


@Component({
  components: {
    Account,
    SelectLayout,
    AccountBalance
  },
  computed: {
    ...mapState({
      isAuthenticated: ({ gamblingContext }: any) => gamblingContext.isAuthenticated,
      currencyCode: ({ gamblingContext }: any) => gamblingContext.currencyCode,
      pageLayoutOptions: ({ gamblingContext }: any) => gamblingContext.pageLayoutOptions,
      pageLayout: ({ gamblingContext }: any) => gamblingContext.pageLayout,
      username: ({ gamblingContext }: any): null | string => gamblingContext.credentials.username,
      email: ({ gamblingContext }: any): null | string => gamblingContext.credentials.email
    })
  }
})

export default class Header extends Vue {
  @Action('logout') logout: any
  @Action('setSidebar') setSidebar: any
  @Mutation('setAccountType') setAccountType: any
  @Mutation('setLogInModal') setLogInModal: any

  $routeChange!: any
  pageLayoutOptions!: string[]
  pageLayout!: string
  openAccountModal: boolean = false
  $smallScreen!: boolean
  $cashierConfigs!: any

  logoutMethod () {
    this.$routeChange('/gambling')
    this.logout()
  }
  logInModal () {
    this.setLogInModal()
  }
  openAccount (type: string) {
    openAccount(type, this)
  }

  depositClick () {
    this.openAccount('banking')
    if (this.pageLayout === 'layout2') {
      this.$router.push('/gambling')
    }
  }
}
